import React from 'react';

import { getHistoryDate } from '../../../../shared/lib';
import { TasksHistoryContent } from '../../../../shared/model/tasks/types';
import { TaskHistoryDate } from '../TaskHistoryDate';
import styles from './TaskHistory.module.css';

interface Props {
  dataId: 'attrApprovalsItem' | 'approvalsHistoryItems';
  values: TasksHistoryContent[];
}

const fields = {
  attrApprovalsItem: { dateField: 'date_startField', userField: 'user_planField' },
  approvalsHistoryItems: { dateField: 'date_actionField', userField: 'user_factField' },
} as const;

export const TaskHistory: React.FC<Props> = ({ dataId, values }) => {
  const { dateField, userField } = fields[dataId];

  return (
    <>
      {values.map((value) => (
        <div className={styles.root} data-id={dataId} key={value.idField}>
          <div className={styles.date}>
            <TaskHistoryDate {...getHistoryDate(value[dateField])} />
          </div>
          <div>
            <div data-id="user">{value[userField]}</div>
            <div data-id="action">{value.actionField}</div>
            <div data-id="type">{value.type_taskField}</div>
          </div>
        </div>
      ))}
    </>
  );
};
